import { stateSetters, stateGetters } from '@/store/store-utils'
import socketActions from '@/store/modules/games/coinflip/socket-actions'
import CoinflipGame from '@/store/models/games/coinflip/CoinflipGame'

const defaultState = {}

export default {
  name: 'games/coinflip',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
    activeGames() {
      return CoinflipGame.query()
        .where('rolled', false)
        .orderBy('total', 'desc')
        .get()
    },
    finishedGames() {
      return CoinflipGame.query()
        .where('rolled', true)
        .orderBy('total', 'desc')
        .get()
    },
  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    ...socketActions,
    async create({ commit }, form) {
      await this.$api.games.coinflip.create(form)
      commit('user/removeItems', form.ids, { root: true })
    },
    async join({ commit }, form) {
      await this.$api.games.coinflip.join(form)
      commit('user/removeItems', form.ids, { root: true })
    },
  },
}
